/**
 * Legacy: Ajax Search
 *
 * Used by: template-parts/header/header-top-bar--desktop.php
 *
 * @module legacy/LAjaxSearch
 */


// Dependances
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';


// ƒs
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
	let $searchForm = $('.site-header__secondary .site-header__search--ajax');
	let searchResultsClass = 'site-header__search__results';
	let $spinner = $( '[data-ajax-search-loading]' ); // V3 header only

	const $v3SearchForm = $( '[data-ajax-search]' );

	if ( $v3SearchForm.length )
	{
		$searchForm = $v3SearchForm;
		searchResultsClass = 'v3-header-d-search__results';
	}

	if ($searchForm.length)
	{
		let $input = $searchForm.find('input[type="search"]');
		let $results = $(`<ul class="${searchResultsClass}"></ul>`);
		let timeout = null;
		const $resetBtn = $( '[data-ajax-search-reset]' );

		$results.appendTo($searchForm);

		$input.on("keyup", function ()
		{
			//InfoData = {slug:GetSearch.value}

			if (timeout)
			{
				clearTimeout(timeout);
			}

			const searchTerm = $input.val();

			if (searchTerm == "")
			{
				$spinner.hide();
				$resetBtn.hide();
				$results.html("");
				return;
			}

			$resetBtn.hide();
			$spinner.show();

			timeout = setTimeout(function ()
			{
				console.log( '[AJAX Search] Searching:', searchTerm );

				$.ajax({
					type: "GET",
					url: '/wp-admin/admin-ajax.php?action=on24_ajax_search_query&search=' + searchTerm,
					success: function (response)
					{
						$spinner.hide();
						$resetBtn.show();

						$results.html("");

						if (response != "0")
						{
							let search_results = $.parseJSON(response);

							console.log( '[AJAX Search] Results:', search_results );

							$.each(search_results, function (_index, value)
							{
								let result = $( `<li><a href="${value.link}">${value.title}</a></li>` );

								result.appendTo( $results );
							});
						}

						timeout = null;
					}
				});
			}, 200);
		});


		// Reset button: Clear results and forget AJAX
		$resetBtn.on( 'click', () =>
		{
			$input.val( '' );
			$results.html( '' );

			$spinner.hide();
			$resetBtn.hide();

			if ( timeout )
			{
				clearTimeout( timeout );
			}
		});
	}
}


// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );
